import styled, { css } from 'styled-components';
import { ParticipantItem } from 'features/ParticipantItem';
import { LARGE_ROOM_PARTICIPANTS_THRESHOLD } from '../../../consts';
import { MEDIA_BREAKPOINTS } from '../consts';

export const StageContainer = styled.div<{ $hasFooter: boolean }>`
    width: 100%;
    height: 100%;
    padding-bottom: ${({ $hasFooter }) => ($hasFooter ? 'var(--desktop-footer-height)' : 0)};
    grid-template-rows: auto min-content;
    overflow: auto;
    display: grid;
    gap: var(--layout-grid-gap);
`;

export const GridParticipantsView = styled.div<{ $participants: number }>`
    display: grid;
    gap: 8px;
    height: 100%;
    align-items: center;
    justify-items: center;
    overflow: auto;
    position: relative;
    z-index: 1;
    box-sizing: border-box;
    padding: 8px 8px 0;

    & > * {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }

    & > [style^='--aspect-ratio']::before {
        content: '';
        display: inline-block;
        width: 1px;
        height: 0;
        padding-bottom: calc(100% / (var(--aspect-ratio)));
    }

    ${({ $participants }) => {
        if ($participants === 1) {
            return css`
                grid-template-columns: auto;
            `;
        } else if ($participants === 2) {
            return css`
                grid-template-columns: repeat(2, 1fr);
            `;
        } else if ($participants <= 4) {
            return css`
                grid-template-columns: repeat(2, 1fr);
                grid-template-rows: minmax(49%, 1fr) minmax(49%, 1fr);
            `;
        } else if ($participants <= 6) {
            return css`
                grid-template-columns: repeat(3, 1fr);
                grid-template-rows: minmax(49%, 1fr) minmax(49%, 1fr);
            `;
        } else if ($participants <= 9) {
            return css`
                grid-template-columns: repeat(3, 1fr);
                grid-template-rows: repeat(3, minmax(32%, 1fr));
            `;
        } else if ($participants <= 12) {
            return css`
                grid-template-columns: repeat(4, 1fr);
                grid-template-rows: repeat(3, minmax(32%, 1fr));
            `;
        } else if ($participants <= 16) {
            return css`
                grid-template-columns: repeat(4, 1fr);
                grid-template-rows: repeat(4, minmax(24%, 1fr));
            `;
        } else if ($participants <= 20) {
            return css`
                grid-template-columns: repeat(5, 1fr);
                grid-template-rows: repeat(4, minmax(24%, 1fr));
            `;
        } else if ($participants <= LARGE_ROOM_PARTICIPANTS_THRESHOLD) {
            return css`
                grid-template-columns: repeat(5, 1fr);
                grid-template-rows: repeat(5, minmax(19%, 1fr));
            `;
        } else {
            return css`
                grid-template-columns: repeat(3, 1fr);
                grid-auto-rows: 32%;

                @media screen and (min-width: ${MEDIA_BREAKPOINTS[0]}px) {
                    grid-template-columns: repeat(4, 1fr);
                    grid-auto-rows: 24%;
                }

                @media screen and (min-width: ${MEDIA_BREAKPOINTS[1]}px) {
                    grid-template-columns: repeat(5, 1fr);
                    grid-auto-rows: 19%;
                }
            `;
        }
    }}
`;

export const GridParticipant = styled(ParticipantItem)`
    height: 100%;
    width: 100%;
    max-height: 80vh;
`;
